import { render, staticRenderFns } from "./confirm-email.vue?vue&type=template&id=2e353a33"
import script from "./confirm-email.vue?vue&type=script&lang=js"
export * from "./confirm-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports